import { global, action } from "../const";
import app_icon from "../../shared/assets/notification_icon.png";
import { onException, getServerResponse } from "../functions";
import notification_icon from '../../shared/assets/notification_icon.png'

export const browserNotification = ({ options, title }) => {
    if (!options.icon) options.icon = app_icon;
    if (!title) title = "Daily Vitals";
    return async (dispatch) => {
        let platform = global.APP_PLATFORM();
        if (platform === "and" || platform === "ios") {
            let result = await Notification.requestPermission();
            if (result === 'granted') {
                navigator.serviceWorker.ready.then((registration) => {
                    registration.showNotification(title, options);
                })
            }
        } else {
            dispatch({
                type: action.SEND_BROWSER_NOTIFICATION,
                payload: { title, options }
            })
        }
        return;
    }
};


export const notifyBrowser = (data) => {
    return (dispatch, getState) => {
        let { auth, chat } = getState();
        let groupList = chat.groupConversation, users = auth.users;
        // console.log("auth", auth.users)

        let title = "", body = "", icon = undefined;
        if (data.cmd === "GroupMessage.receive") {
            let group = groupList.filter(item => item.target === data.target)
            group = group[0] ? group[0] : [];
            let user = users[data.sender];
            // console.log("user", user)
            title = group.group_name;
            body = (user && user.nickname || 'message') + " : " + data.message;
            icon = user == null ? notification_icon : global.MAKEURL(user && user.avatar);
        } else {
            title = data.target_name;
            body = data.sender_name + " has" + data.event_type === 0 ? 'join' : 'quit' + data.target_type === 0 ? 'family' : 'team/village';
            icon = notification_icon;
        }

        dispatch(browserNotification({
            title,
            options: {
                body,
                icon
            }
        }))
    }
};

// [#218 User1.uploadDeviceInfo]
export const uploadDeviceInfo = (ios_token) => {
    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        try {
            let response = await getServerResponse({
                cmd: "User1.uploadDeviceInfo",
                user_id: userInfo.id,
                ios_token
            })
            return response
        } catch (error) {
            onException(error)
        }
    }
}

// get android notification click
export const getClickNotification = () => {
    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        try {
            let response = await getServerResponse({
                cmd: "WcnIntent.get"
            })
            return response
        } catch (error) {
            onException(error)
        }
    }
}

// [#227 WcnFunction.getVbReport]
export const getVbReport = (war_id) => {
    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        try {
            let response = await getServerResponse({
                cmd: "WcnFunction.getVbReport",
                token: userInfo.token,
                war_id
            });
            if(response.error) return;
            return response
        } catch (error) {
            onException(error)
        }
    }
}